export default "__VITE_ASSET__d2721fe6__"